import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Dimensions } from '../_models/dimensions';
import { DimensionData } from '../_models/dimensionData';

@Injectable({
  providedIn: 'root'
})
export class DimensionsService {
  baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  transactionReceived = new BehaviorSubject<[number, string]>([0, '']);
  tranReceived(id: number, dimType: string) {
    this.transactionReceived.next([id, dimType]);

  }

  getDimensions(id: number, type: string) {
    return this.http.get<Dimensions>(this.baseUrl + 'dimension/data/' + id + '/' + type);
  }
}
